import * as React from "react"

const RweFar = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M387 376c17.121 0 31-13.879 31-31 0-17.121-13.879-31-31-31-17.121 0-31 13.879-31 31 0 17.121 13.879 31 31 31Z"
            fill="#B5179E"
        />
        <path
            d="M415 394c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z"
            fill="#560BAD"
        />
        <path
            d="M344 409c17.121 0 31-13.879 31-31 0-17.121-13.879-31-31-31-17.121 0-31 13.879-31 31 0 17.121 13.879 31 31 31Z"
            fill="#F72585"
        />
        <path
            d="M351 446c17.121 0 31-13.879 31-31 0-17.121-13.879-31-31-31-17.121 0-31 13.879-31 31 0 17.121 13.879 31 31 31Z"
            fill="#560BAD"
        />
        <path
            d="M327.5 488a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
            fill="#B5179E"
        />
        <path
            d="M376 525a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM468 384c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25Z"
            fill="#7209B7"
        />
        <path
            d="M424 334c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17Z"
            fill="#B5179E"
        />
    </svg>
)

export default RweFar
